import React, { useState, useEffect, useMemo, useContext, Activity, useRef } from "react";
import Table from "../../components/table/table";
import Card from "../../components/Card";
import classNames from "classnames";
import IconCalendrier from '../../assets/icons/iconCalendrier.svg'

import { GetCalledClients } from "../../helpers/api";
import { UserContext } from "../../contexts/UserContext";
import {IconTrackingAppel,IconTrackingTransfert,IconTrackingFacture,IconTrackingActivity} from '../../assets/indexIcon'
import FiltreDate from "../../components/FiltreDate";
const AgentClientTracking = () => {
  const { user } = useContext(UserContext);
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const formatDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
  }

const [startDate, setStartDate] = useState(() => {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return formatDate(d);
});

const [endDate, setEndDate] = useState(() => formatDate(new Date()));
  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GetCalledClients(
          user?.accessToken,
          user?.user?.id,
          startDate,
          endDate          

        )
        if (response && response.clients) {
          setApiData(response);
        }
      } catch (error) {
        console.error("Error fetching clients:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (user?.accessToken && user?.user?.id) {
      fetchData();
    }
  }, [user?.accessToken, user?.user?.id, startDate, endDate]);

  const getClientStatus = (client) => {
    const transfers = client.stats?.validTransfers || 0;
    if (transfers === 0) return "En attente";
    if (transfers >= 3) return "VIP Client";
    return "Actif";
  };

  // const filteredData = useMemo(() => {
  //   return apiData.filter((client) => {
  //     if (!startDate && !endDate) return true;
  //     const created = client.createdAt
  //       ? new Date(client.createdAt)
  //       : new Date();
  //     const start = startDate ? new Date(startDate) : null;
  //     const end = endDate ? new Date(endDate) : null;

  //     if (start && created < start) return false;
  //     if (end && created > end) return false;
  //     return true;
  //   });
  // }, [apiData, startDate, endDate]);


  const stats = useMemo(() => {
    return {
      total: apiData.totalCalls,
      transfers: apiData.transfersAfterCall,
      invoices: apiData.invoicesAfterCall,
      Active: apiData.transfersAfterCall + apiData.invoicesAfterCall
      // active: apiData.filter((c) => (c.stats?.transfersAfterCall || 0) > 0)
      //   .length,
    };
  }, [apiData]);

  const columns = [

    {
      label: "Order",
      key: "order",
      customRenderers: (row) => (
        <span>{row.order}</span>
      ),
    },
    {
      key: "name",
      label: "CLIENT",
      customRenderers: (row) => (
       
         <div>
         <a
           href={`/detailuser/${row._id}`}
           target="_blank"
           rel="noopener noreferrer"
           className="text-[#777777] underline  hover:text-blue-800"
           onClick={(e) => {
             localStorage.setItem(
               "varaction",
               JSON.stringify({ actionId: null, actionType: null }),
             );
             e.stopPropagation();
           }}
         >
           {row.firstName} {row.lastName} 
         </a>
       </div>
      ),
    },
    {
      key: "phone",
      label: "CONTACT",
      customRenderers: (row) => (
        <div className="text-left">
          <span className="text-slate-600 font-mono text-[11px]">
            +{row.phone?.prefix} {row.phone?.number}
          </span>
        </div>
      ),
    },
    // {
    //   key: "status",
    //   label: "STATUS",
    //   customRenderers: (row) => {
    //     const s = getClientStatus(row);
    //     const colors = {
    //       "En attente": "bg-amber-50 text-amber-600 border-amber-100",
    //       Actif: "bg-emerald-50 text-emerald-600 border-emerald-100",
    //       "VIP Client": "bg-violet-50 text-violet-600 border-violet-100",
    //     };
    //     return (
    //       <div className="text-left">
    //         <span
    //           className={classNames(
    //             "px-2 py-0.5 rounded-md text-[9px] font-black uppercase border",
    //             colors[s]
    //           )}
    //         >
    //           {s}
    //         </span>
    //       </div>
    //     );
    //   },
    // },
    {
      key: "validTransfers",
      label: "TRANSFERTS",
      customRenderers: (row) => (
        <div className="text-center font-black text-[#5754E5] bg-[#5754E5]/15 py-2 w-[100px] rounded-[8px]">
          {row.transfersCount || 0}
        </div>
      ),
    },
    {
      key: "validInvoices",
      label: "FACTURES",
      customRenderers: (row) => (
        <div className="text-center font-black text-[#38C3FF] bg-[#38C3FF]/15 py-2 w-[100px] rounded-[8px]">
          {row.invoicesCount || 0}
        </div>
      ),
    },
    {
      key: "validRecharges",
      label: "RECHARGES",
      customRenderers: (row) => (
        <div className="text-center font-bold text-[#FFC000] bg-[#FFC000]/15 py-2 w-[100px] rounded-[8px]">
          {row.rechargesCount || 0}
        </div>
      ),
    },
  ];

  const startDateRef =useRef(null)
  const endDateRef =useRef(null)

  return (
    <div className="p-4 md:p-8 min-h-screen font-sans">
      <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
      
          <h1 className="h2-title ">
            Tracking Appels Clients
          </h1>
                <FiltreDate setStartDate={setStartDate}  setEndDate={setEndDate}/>

       
        <div className="flex gap-2 bg-white p-2 rounded-xl shadow-sm border border-slate-200">
          <input
          ref={startDateRef}
            type="date"
            value={startDate}
            max={endDate}
            onChange={(e) =>setStartDate(e.target.value)}
            className="text-[11px] font-bold text-[#5d55e8] outline-none p-1"
          />
           <img className="w-[15px] h-auto" 
           src={IconCalendrier} 
           alt="IconCalendrier" 
           onClick={() => startDateRef.current?.showPicker?.()}
           width={20} height={22}
           />

          <span className="text-slate-300 self-center">→</span>
          <input
          ref={endDateRef}
            type="date"
            value={endDate}
            // min={startDate}
            max={new Date().toISOString().split("T")[0]}
            onChange={(e) =>{
              const newEnd= e.target.value
              if(newEnd > startDate) {
              setEndDate(newEnd)
            }}}
            className="text-[11px] font-bold text-[#5d55e8] outline-none p-1"
          />
           <img className="w-[15px] h-auto"  
           src={IconCalendrier} 
           alt="IconCalendrier" 
           onClick={() => endDateRef.current?.showPicker?.()} 
           width={20} height={22}
           />
          
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <Card
          title="Total Appels"
          value={stats.total}
          icon={IconTrackingAppel}
         
        />
        <Card
          title="Transferts Valides"
          value={stats.transfers}
          icon={IconTrackingTransfert}
        /> 
        <Card
          title="Factures Payées"
          value={stats.invoices}
          icon={IconTrackingFacture}
        />
        <Card
          title="Taux d'Activité"
          value={
            stats.total > 0
             ? `${((stats.Active / stats.total) * 100).toFixed(0)}%`
              : "0%"
          }
          icon={IconTrackingActivity}
        />
      </div>

      <div className="bg-white rounded-xl shadow-2xl border border-[#EEEEEE] w-full p-4 md:p-6 overflow-hidden">
        
          <Table
            totalPage={totalPage}
            setPageSize={setPageSize}
            pageSize={pageSize}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setPageLimit={setPageSize}
            pageLimit={pageSize}
            loading={isLoading}
            data={apiData.clients}
            columns={columns}
            excel={true}
            titleTable='Détails des portefeuilles clients'
          />
      </div>
    </div>
  );
};

export default AgentClientTracking;
